import {ArrowBack} from '@mui/icons-material';
import {Button, CircularProgress, Stack} from '@mui/material';

export interface AdminQuestionViewHeaderProps {
  onBack: () => void;
  onCheckWithRules: () => void;
  onCheckWithGpt: () => void;
  onGenerateGraphJson: () => void;
  onSave: () => void;
  onNavigateToSeedQuestion?: () => void;
  seedQuestionId?: string | null;
  checkRulesLoading: boolean;
  checkGptLoading: boolean;
  generateGraphLoading: boolean;
  updateLoading: boolean;
}

export default function AdminQuestionViewHeader({
  onBack,
  onCheckWithRules,
  onCheckWithGpt,
  onGenerateGraphJson,
  onSave,
  onNavigateToSeedQuestion,
  seedQuestionId,
  checkRulesLoading,
  checkGptLoading,
  generateGraphLoading,
  updateLoading,
}: AdminQuestionViewHeaderProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 3}}>
      <Button
        startIcon={<ArrowBack />}
        onClick={onBack}
        sx={{
          color: '#1B263B',
          '&:hover': {bgcolor: 'rgba(27, 38, 59, 0.04)'},
        }}
      >
        Back to Questions
      </Button>
      {seedQuestionId && onNavigateToSeedQuestion && (
        <Button
          onClick={onNavigateToSeedQuestion}
          variant="outlined"
          sx={{
            borderColor: '#1B263B',
            color: '#1B263B',
            '&:hover': {borderColor: '#1B263B', bgcolor: '#1B263B', color: 'white'},
          }}
        >
          View Seed Question
        </Button>
      )}
      <Button
        onClick={onCheckWithRules}
        variant="outlined"
        disabled={checkRulesLoading || checkGptLoading || updateLoading}
        sx={{
          borderColor: '#1B263B',
          color: '#1B263B',
          '&:hover': {borderColor: '#1B263B', bgcolor: '#1B263B', color: 'white'},
        }}
      >
        {checkRulesLoading ? <CircularProgress size={20} /> : 'Check with Rules'}
      </Button>
      <Button
        onClick={onCheckWithGpt}
        variant="outlined"
        disabled={checkRulesLoading || checkGptLoading || updateLoading}
        sx={{
          borderColor: '#1B263B',
          color: '#1B263B',
          '&:hover': {borderColor: '#1B263B', bgcolor: '#1B263B', color: 'white'},
        }}
      >
        {checkGptLoading ? <CircularProgress size={20} /> : 'Check with GPT'}
      </Button>
      <Button
        onClick={onGenerateGraphJson}
        variant="outlined"
        disabled={generateGraphLoading || updateLoading}
        sx={{
          borderColor: '#FF6F59',
          color: '#FF6F59',
          '&:hover': {borderColor: '#FF6F59', bgcolor: '#FF6F59', color: 'white'},
        }}
      >
        {generateGraphLoading ? <CircularProgress size={20} /> : 'Generate Graph JSON'}
      </Button>
      <Button
        onClick={onSave}
        variant="contained"
        disabled={updateLoading}
        sx={{
          bgcolor: '#1B263B',
          '&:hover': {bgcolor: '#1B263B', opacity: 0.8},
        }}
      >
        {updateLoading ? <CircularProgress size={20} color="inherit" /> : 'Save Changes'}
      </Button>
    </Stack>
  );
}
